export const serviceDataArabic = {
	"Name": "GuidedJourneyJSON",
	"Enable": true,
	"Items": [
		{
			"SRType": "Membership||New Membership",
			"serviceNameForList": "SR_MEMBERSHIP_REG",
			"id": "membership-registration",
			"sequence": 39,
			"serviceName": "عضوية جديدة",
			"serviceNameKey": "MEMBERSHIP_NEW",
			"organization": "Membership",
			"parentServiceKey": "MEMBERSHIP",
			"accessFlagKey": "DC Membership Services Flag",
			"PreText": "من خلال الانضمام كعضو، ستحصل على مجموعة واسعة من المزايا الحصرية، بما في ذلك سهولة التسجيل، ودعم نمو الأعمال، وفرص التواصل وبناء شبكة علاقات مهنية، إلى جانب الإرشاد المتخصص. يمكن لشركات البر الرئيسي والمناطق الحرة التي تمارس أنشطة تجارية أو صناعية أو مهنية التسجيل للحصول على العضوية.",
			"serviceDetail": {
				"description": "من خلال الانضمام كعضو، ستحصل على مجموعة واسعة من المزايا الحصرية، بما في ذلك سهولة التسجيل، ودعم نمو الأعمال، وفرص التواصل وبناء شبكة علاقات مهنية، إلى جانب الإرشاد المتخصص. يمكن لشركات البر الرئيسي والمناطق الحرة التي تمارس أنشطة تجارية أو صناعية أو مهنية التسجيل للحصول على العضوية.",
				"processingTime": "ساعتان",
				"feesNote": "من AED 300 إلى AED 2,200"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على «بدء الخدمة» لإنشاء حسابك أو لتسجيل الدخول إلى منصة خدمات غرف دبي. ويمكنك أيضًا الوصول إلى الخدمة عبر تطبيق الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "اتبع التعليمات لتقديم جميع المستندات المطلوبة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع وإصدار شهادة العضوية",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل شهادة العضوية الخاصة بك."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لشركات البر الرئيسي والمناطق الحرة التي تمارس أنشطة تجارية أو صناعية أو مهنية التسجيل للحصول على العضوية."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية لأنواع مختلفة من المنشآت:",
				"list": [
					{
						"title": "مؤسسة فردية",
						"description": "رخصة تجارية سارية المفعول؛ نسخة من جواز سفر صاحب الرخصة أو المحامي أو بطاقة الهوية الإماراتية؛ ونسخة من وكالة قانونية أصولية عند الاقتضاء.",
						"documents": [
							{
								"title": "رخصة تجارية سارية المفعول"
							},
							{
								"title": "نسخة من جواز سفر صاحب الرخصة أو المحامي أو بطاقة الهوية الإماراتية"
							},
							{
								"title": "نسخة من الوكالة القانونية المصدّقة أصولاً (إن وجدت)"
							}
						]
					},
					{
						"title": "الشركات المحلية",
						"description": "رخصة تجارية سارية المفعول؛",
						"documents": [
							{
								"title": "رخصة تجارية سارية المفعول"
							},
							{
								"title": "نسخ من جوازات السفر أو بطاقات الهوية الإماراتية للشركاء أو المدراء أو الوكيل القانوني"
							},
							{
								"title": "عقد التأسيس الموثّق والمصدّق أصولاً"
							},
							{
								"title": "وكالة قانونية مصدّقة أصولاً"
							}
						]
					},
					{
						"title": "الشركات الأجنبية ومكاتب التمثيل",
						"description": "",
						"documents": [
							{
								"title": "رخصة تجارية سارية المفعول"
							},
							{
								"title": "نسخة من جواز سفر المدير أو الوكيل المعيّن أو بطاقة الهوية الإماراتية"
							},
							{
								"title": "عقد تأسيس الشركة الأم موثّق ومصدّق أصولاً"
							},
							{
								"title": "وكالة قانونية مصدّقة أصولاً للمدير أو الوكيل"
							}
						]
					},
					{
						"title": "شركات ومؤسسات المناطق الحرة",
						"description": "",
						"documents": [
							{
								"title": "نسخة من رخصة تجارية سارية المفعول"
							},
							{
								"title": "نسخة من جواز سفر المدير أو الوكيل أو بطاقة الهوية الإماراتية"
							},
							{
								"title": "عقد تأسيس/شهادة أسهم/شهادة تأسيس مصدّقة أصولاً"
							},
							{
								"title": "خطاب تفويض صادر من المدير لصالح الوكيل (إن وُجد)"
							}
						]
					}
				]
			},
			"serviceFees": [
				{
					"title": "تُحدَّد الرسوم السنوية بناءً على الشكل القانوني وجنسية المالكين أو نوع نشاط المنشأة/الشركة، وتصنَّف كالتالي:",
					"list": [
						"المنشآت الوطنية (التي تمارس أنشطة محددة): AED 700",
						"التجارة العامة: AED 1,200 - AED 2,200",
						"البنوك، شركات التأمين، مقاولون البناء، فروع الشركات الأجنبية العالمية: AED 2,200",
						"شركات المناطق الحرة: AED 2,200",
						"الفنادق، والخدمات المالية ذات الصلة، ووسطاء التأمين: AED 2,000 - AED 2,200",
						"مكاتب المحاماة، ومكاتب التدقيق، والمهندسون الاستشاريون: AED 1,000 - AED 2,200",
						"أنشطة التجارة البسيطة المتنوعة: AED 500",
						"الحرف اليدوية، التجار الإلكترونيون، ورخصة انطلاق: AED 300",
						"الحرف البسيطة: AED 50.",
						"فروع المنشآت التي تحمل الاسم التجاري نفسه: AED 100 - AED 2,200 (وفقًا للنشاط).",
						"إعفاء لمدة 5 سنوات للأعضاء المسجّلين في مؤسسة محمد بن راشد لتنمية المشاريع الصغيرة والمتوسطة.",
						"*قد يختلف إجمالي مبلغ رسوم الخدمة حسب متطلباتك المحددة."
					]
				}
			],
			"resources": [
				{
					"title": "بدء الخدمة – عضوية جديدة",
					"url": "https://dcdigitalservices.dubaichamber.com"
				},
				{
					"title": "خدمة ذات صلة – تجديد العضوية",
					"url": "https://dcdigitalservices.dubaichamber.com"
				},
				{
					"title": "خدمة ذات صلة – إلغاء العضوية",
					"url": "https://dcdigitalservices.dubaichamber.com"
				}
			]
		},

		{
			"SRType": "Membership||Cancellation",
			"serviceNameForList": "SR_MEMBERSHIP_CANCELLATION",
			"id": "membership-cancellation",
			"sequence": 21,
			"serviceName": "إلغاء العضوية",
			"serviceNameKey": "MEMBERSHIP_CANCELLATION",
			"organization": "Membership",
			"parentServiceKey": "MEMBERSHIP",
			"accessFlagKey": "DC Membership Services Flag",
			"PreText": "طلب إلغاء العضوية",
			"serviceDetail": {
				"description": "إذا كانت شركتك بصدد التصفية أو الحل، فقد تحتاج إلى إلغاء عضويتك في غرفة تجارة دبي. بإلغاء العضوية، لن تتمكن من الاستفادة من المزايا الحصرية، بما في ذلك سهولة التسجيل، ودعم نمو الأعمال، وفرص التواصل، والإرشاد المتخصص.",
				"processingTime": "ساعتان",
				"feesNote": "لا توجد رسوم"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على «بدء الخدمة» لإنشاء حسابك أو لتسجيل الدخول إلى منصة خدمات غرف دبي. كما يمكنك الوصول إلى الخدمة عبر تطبيق الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "قم بتقديم الطلب والمستندات المطلوبة من خلال الموقع الإلكتروني أو تطبيق الهاتف المتحرك."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "التأكيد",
					"description": "ستتلقى تأكيدًا يفيد بأنه تم إلغاء عضويتك."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن للأعضاء المسجلين حاليًا إلغاء عضويتهم."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية لأنواع مختلفة من المنشآت:",
				"list": [
					{
						"title": "المنطقة الحرة",
						"description": "",
						"documents": [
							{
								"title": "رسالة طلب من الشركة موقعة من الشخص المخوَّل بالتوقيع."
							}
						]
					},
					{
						"title": "البر الرئيسي",
						"description": "",
						"documents": [
							{
								"title": "خطاب إلغاء من دائرة الاقتصاد والسياحة (DET)."
							}
						]
					}
				]
			},
			"serviceFees": [
				{
					"title": "لا توجد رسوم",
					"list": []
				}
			],
			"resources": [
				{
					"title": "عضوية شهادة المنشأ",
					"url": "https://www.dubaichambers.com/en"
				},
				{
					"title": "الأسئلة الشائعة",
					"url": "https://www.dubaichambers.com/en"
				},
				{
					"title": "دليل الخدمات",
					"url": "https://www.dubaichambers.com/en"
				}
			]
		},

		{
			"SRType": "Membership||Renew Membership",
			"serviceNameForList": "SR_MEMBERSHIP_RENEW",
			"id": "membership-renewal",
			"sequence": 19,
			"serviceName": "تجديد العضوية",
			"serviceNameKey": "MEMBERSHIP_RENEW",
			"organization": "Membership",
			"parentServiceKey": "MEMBERSHIP",
			"accessFlagKey": "DC Membership Services Flag",
			"PreText": "التجديد السنوي للعضوية",
			"serviceDetail": {
				"description": "من خلال كونك عضوًا، تستفيد من مجموعة واسعة من المزايا الحصرية، بما في ذلك سهولة التسجيل، ودعم نمو الأعمال، وفرص التواصل، والإرشاد المتخصص. يمكن لشركات البر الرئيسي والمناطق الحرة التي تمارس أنشطة تجارية أو صناعية أو مهنية الاستمرار في عضويتها عبر التجديد السنوي.",
				"processingTime": "ساعتان",
				"feesNote": "من AED 300 إلى AED 2,200"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على «بدء الخدمة» لإنشاء حسابك أو لتسجيل الدخول إلى منصة خدمات غرف دبي. كما يمكنك الوصول إلى الخدمة عبر تطبيق الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "اتبع التعليمات لتقديم جميع المستندات المطلوبة للتجديد."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع وإصدار شهادة العضوية",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل شهادة العضوية المجددة."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لشركات البر الرئيسي والمناطق الحرة التي تمارس أنشطة تجارية أو صناعية أو مهنية الاستمرار في عضويتها عبر تجديد العضوية."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية لأنواع مختلفة من المنشآت:",
				"list": [
					{
						"title": "مؤسسة فردية",
						"description": "رخصة تجارية سارية المفعول؛ نسخة من جواز سفر صاحب الرخصة أو المحامي أو بطاقة الهوية الإماراتية؛ ونسخة من وكالة قانونية مصدّقة أصولاً عند الاقتضاء.",
						"documents": [
							{
								"title": "رخصة تجارية سارية المفعول"
							},
							{
								"title": "نسخة من جواز سفر صاحب الرخصة أو المحامي أو بطاقة الهوية الإماراتية"
							},
							{
								"title": "نسخة من الوكالة القانونية المصدّقة أصولاً (إن وجدت)"
							}
						]
					},
					{
						"title": "الشركات المحلية",
						"description": "رخصة تجارية سارية المفعول؛",
						"documents": [
							{
								"title": "رخصة تجارية سارية المفعول"
							},
							{
								"title": "نسخ جوازات السفر أو بطاقات الهوية الإماراتية للشركاء أو المدراء أو الوكيل المعتمد"
							},
							{
								"title": "عقد التأسيس الموثّق والمصدّق أصولاً"
							},
							{
								"title": "وكالة قانونية مصدّقة أصولاً"
							}
						]
					},
					{
						"title": "الشركات الأجنبية ومكاتب التمثيل",
						"description": "",
						"documents": [
							{
								"title": "رخصة تجارية سارية المفعول"
							},
							{
								"title": "نسخة من جواز سفر المدير أو الوكيل المعيّن أو بطاقة الهوية الإماراتية"
							},
							{
								"title": "عقد تأسيس الشركة الأم موثّق ومصدّق أصولاً"
							},
							{
								"title": "وكالة قانونية مصدّقة أصولاً للمدير أو الوكيل"
							}
						]
					},
					{
						"title": "شركات ومؤسسات المناطق الحرة",
						"description": "",
						"documents": [
							{
								"title": "نسخة من الرخصة التجارية سارية المفعول"
							},
							{
								"title": "نسخة من جواز سفر المدير أو الوكيل المعيّن أو بطاقة الهوية الإماراتية"
							},
							{
								"title": "عقد تأسيس/شهادة أسهم/شهادة تأسيس مصدّقة أصولاً"
							},
							{
								"title": "خطاب تفويض من المدير لصالح الوكيل (إن عُيِّن)"
							}
						]
					}
				]
			},
			"serviceFees": [
				{
					"title": "تُحدَّد الرسوم السنوية بناءً على الشكل القانوني وجنسية المالكين أو نوع نشاط المنشأة/الشركة، وتصنَّف كالتالي:",
					"list": [
						"المنشآت الوطنية (التي تمارس أنشطة محددة): AED 700",
						"التجارة العامة: AED 1,200 - AED 2,200",
						"البنوك، شركات التأمين، مقاولون البناء، فروع الشركات الأجنبية العالمية: AED 2,200",
						"شركات المناطق الحرة: AED 2,200",
						"الفنادق، والخدمات المالية ذات الصلة، ووسطاء التأمين: AED 2,000 - AED 2,200",
						"مكاتب المحاماة، ومكاتب التدقيق، والمهندسون الاستشاريون: AED 1,000 - AED 2,200",
						"أنشطة التجارة البسيطة المتنوعة: AED 500",
						"الحرف اليدوية، التجار الإلكترونيون، ورخصة انطلاق: AED 300",
						"الحرف البسيطة: AED 50.",
						"فروع المنشآت التي تحمل الاسم التجاري نفسه: AED 100 - AED 2,200 (وفقًا للنشاط).",
						"إعفاء لمدة 5 سنوات لأعضاء مؤسسة محمد بن راشد لتنمية المشاريع الصغيرة والمتوسطة.",
						"*قد يختلف إجمالي مبلغ رسوم الخدمة حسب متطلباتك المحددة."
					]
				}
			],
			"resources": [
				{
					"title": "بدء الخدمة – تجديد العضوية",
					"url": "https://dcdigitalservices.dubaichamber.com"
				},
				{
					"title": "خدمة ذات صلة – عضوية جديدة",
					"url": "https://dcdigitalservices.dubaichamber.com"
				},
				{
					"title": "خدمة ذات صلة – تعديل العضوية",
					"url": "https://dcdigitalservices.dubaichamber.com"
				},
				{
					"title": "خدمة ذات صلة – إلغاء العضوية",
					"url": "https://dcdigitalservices.dubaichamber.com"
				}
			]
		},

		{
			"SRType": "Membership||Amendment Membership",
			"serviceNameForList": "SR_MEMBERSHIP_AMD",
			"id": "membership-amendment",
			"sequence": 18,
			"serviceName": "تعديل العضوية",
			"serviceNameKey": "MEMBERSHIP_AMENDMENT",
			"organization": "Membership",
			"parentServiceKey": "MEMBERSHIP",
			"accessFlagKey": "DC Membership Services Flag",
			"PreText": "تعديل/تحديث بيانات العضوية",
			"serviceDetail": {
				"description": "حافظ على تحديث ملف عضويتك للاستمرار في الاستفادة من مجموعة واسعة من المزايا الحصرية، بما في ذلك سهولة التسجيل، ودعم نمو الأعمال، وفرص التواصل، والإرشاد المتخصص.",
				"processingTime": "ساعتان",
				"feesNote": "AED 100"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على «بدء الخدمة» لإنشاء حسابك أو لتسجيل الدخول إلى منصة خدمات غرف دبي. كما يمكنك الوصول إلى الخدمة عبر تطبيق الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "اتبع التعليمات لتقديم جميع المستندات المطلوبة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع وإصدار شهادة العضوية",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل شهادة العضوية الخاصة بك."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن للأعضاء المسجّلين حاليًا تحديث وتعديل بيانات عضويتهم."
				}
			],
			"serviceRequirements": {
				"title": "لتحديث أو تعديل عضويتك، يرجى تقديم نسخة من المستند المعدل (مثل عقد التأسيس، أو نسخة بطاقة الهوية الإماراتية للشريك/المدير، أو نسخة جواز السفر).",
				"list": [
					{
						"title": "المستندات",
						"description": "",
						"documents": [
							{
								"title": "عقد التأسيس"
							},
							{
								"title": "نسخة بطاقة الهوية الإماراتية للشريك/المدير أو جواز السفر"
							}
						]
					}
				]
			},
			"serviceFees": [
				{
					"title": "رسوم تعديل العضوية: AED 100",
					"list": []
				}
			],
			"resources": [
				{
					"title": "بدء الخدمة – تعديل العضوية",
					"url": "https://dcdigitalservices.dubaichamber.com"
				},
				{
					"title": "خدمة ذات صلة – عضوية جديدة",
					"url": "https://dcdigitalservices.dubaichamber.com"
				},
				{
					"title": "خدمة ذات صلة – تجديد العضوية",
					"url": "https://dcdigitalservices.dubaichamber.com"
				},
				{
					"title": "خدمة ذات صلة – إلغاء العضوية",
					"url": "https://dcdigitalservices.dubaichamber.com"
				}
			]
		},

		{
			"SRType": "Membership||Manage Signatories",
			"serviceNameForList": "SR_MEMBERSHIP_MANAGE_SIGNATORIES",
			"id": "membership-manage-signatories",
			"sequence": 20,
			"serviceName": "إدارة المخولين بالتوقيع",
			"serviceNameKey": "MEMBERSHIP_MANAGEMENT_SIGNATORIES",
			"organization": "Membership",
			"parentServiceKey": "MEMBERSHIP",
			"accessFlagKey": "DC Membership Services Flag",
			"PreText": "يمكنك إضافة/إزالة المخولين بالتوقيع الحاليين فقط. لإضافة مخولين جدد، يرجى استخدام خدمة تعديل العضوية.",
			"serviceDetail": {
				"description": "يمكنك إضافة أو إزالة المخولين بالتوقيع الحاليين فقط. لإضافة مخولين جدد، يرجى التوجّه إلى خدمة تعديل العضوية.",
				"processingTime": "ساعتان",
				"feesNote": "لا توجد رسوم"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على «بدء الخدمة» لإنشاء حسابك أو لتسجيل الدخول إلى منصة خدمات غرف دبي. كما يمكنك الوصول إلى الخدمة عبر تطبيق الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "اتبع التعليمات لتقديم جميع المستندات المطلوبة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "إصدار الشهادة",
					"description": "بعد الموافقة، ستتمكن من تنزيل شهادة العضوية الخاصة بك."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن للأعضاء المسجّلين حاليًا تحديث وتعديل بيانات عضويتهم."
				}
			],
			"serviceRequirements": {
				"title": "يرجى التأكد من توفر المتطلبات التالية للاستفادة من الخدمة:",
				"list": [
					{
						"title": "إضافة مخولين جدد بالتوقيع (قائمة المستندات)",
						"description": "",
						"documents": [
							{
								"title": "بطاقة التوقيع/نسخة من بطاقة الهوية الإماراتية"
							},
							{
								"title": "وكالة قانونية صادرة من كاتب العدل (مطلوبة للرخص غير التابعة للمناطق الحرة)."
							},
							{
								"title": "نسخة من الرخصة"
							},
							{
								"title": "عقد التأسيس/شهادة الأسهم/شهادة التأسيس/النظام الأساسي."
							},
							{
								"title": "إما نسخة جواز السفر أو بطاقة الهوية الإماراتية"
							},
							{
								"title": "خطاب تفويض على ورق الشركة، مختوم وموقّع من المخوَّل بالتوقيع (مطلوب للرخص التابعة للمناطق الحرة)"
							}
						]
					},
					{
						"title": "إزالة المخولين بالتوقيع (قائمة المستندات)",
						"description": "",
						"documents": [
							{
								"title": "خطاب طلب من الشخص المخوَّل لإزالة الموقّع (مطلوب في حالة إزالة مفوض حالي بالتوقيع)"
							},
							{
								"title": "عقد تأسيس معدّل (مطلوب للرخص غير التابعة للمناطق الحرة)"
							}
						]
					}
				]
			},
			"serviceFees": [
				{
					"title": "لا توجد رسوم",
					"list": []
				}
			],
			"resources": [
				{
					"title": "بدء الخدمة – تعديل العضوية",
					"url": "https://dcdigitalservices.dubaichamber.com"
				},
				{
					"title": "خدمة ذات صلة – عضوية جديدة",
					"url": "https://dcdigitalservices.dubaichamber.com"
				},
				{
					"title": "خدمة ذات صلة – تجديد العضوية",
					"url": "https://dcdigitalservices.dubaichamber.com"
				},
				{
					"title": "خدمة ذات صلة – إلغاء العضوية",
					"url": "https://dcdigitalservices.dubaichamber.com"
				}
			]
		},

		{
			"SRType": "Certificate Of Origin||Issue New COO",
			"serviceNameForList": "SR_ISSUE_COO",
			"id": "coo",
			"sequence": 1,
			"PreText": "تتيح لك هذه الخدمة التقدم بطلب للحصول على شهادة منشأ، وهي وثيقة رسمية تحدد منشأ البضائع المصدّرة أو المعاد تصديرها. تُستخدم في تحديد التعرفة الجمركية ويجب أن تُرفَق بفاتورة تجارية مفصلة. يضمن الحصول على هذه الشهادة الامتثال للوائح الجمركية.",
			"serviceName": "إصدار شهادة منشأ",
			"serviceNameKey": "ISSUE_NEW_COO",
			"organization": "Certificate Of Origin",
			"parentServiceKey": "COO",
			"accessFlagKey": "DC COO Services Flag",
			"url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin",
			"serviceDetail": {
				"description": "تتيح لك هذه الخدمة التقدم بطلب للحصول على شهادة منشأ، وهي وثيقة رسمية تحدد منشأ البضائع المصدّرة أو المعاد تصديرها. تُستخدم في تحديد التعرفة الجمركية ويجب أن تُرفَق بفاتورة تجارية مفصلة. يضمن الحصول على هذه الشهادة الامتثال للوائح الجمركية.",
				"processingTime": "ساعتان",
				"feesNote": "AED 100"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على \"بدء الخدمة\" لتسجيل الدخول أو التسجيل في منصة خدمات غرف دبي، أو افتح الخدمة من خلال تطبيق غرف دبي على الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "أكمِل النموذج الإلكتروني وحمّل جميع الوثائق المطلوبة المتعلقة بالشحنة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل شهادة المنشأ."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية لإصدار شهادة منشأ:",
				"list": [
					{
						"title": "المستند الأساسي",
						"description": "شحنة مباشرة",
						"documents": [
							{
								"title": "الفاتورة"
							},
							{
								"title": "بوليصة الشحن"
							}
						]
					},
					{
						"title": "منشأ الإمارات",
						"description": "بوليصة الشحن عند إرسال الشحنة مباشرة إلى بلد المقصد.",
						"documents": [
							{
								"title": "نسخة من الرخصة الصناعية"
							},
							{
								"title": "نسخة من فاتورة المصنع"
							}
						]
					},
					{
						"title": "بضائع ترانزيت",
						"description": "نسخة من بيان الترانزيت من جمارك دبي",
						"documents": [
							{
								"title": "نسخة من بيان الترانزيت من جمارك دبي"
							}
						]
					},
					{
						"title": "يرجى العلم بأن غرف دبي تحتفظ بحقها في طلب أي مستندات داعمة إضافية إذا لزم الأمر، بما في ذلك:",
						"description": "نسخة من بيان الترانزيت من جمارك دبي",
						"documents": [
							{
								"title": "قائمة التعبئة"
							},
							{
								"title": "فواتير بلد التصدير"
							},
							{
								"title": "فاتورة بلد المصدّر"
							}
						]
					}
				]
			},
			"serviceFees": [
				{
					"title": "رسوم الخدمة",
					"list": [
						"إصدار شهادة منشأ: AED 100.",
						"AED 5 عن كل صفحة إضافية بعد الصفحة الخامسة من الفاتورة التجارية.",
						"AED 5 عن كل صفحة من صفحات قائمة التعبئة."
					]
				}
			],
			"additionalInformation": {
				"otherChannels": "يمكنك أيضًا التقديم من خلال تطبيق غرف دبي للهواتف المتحركة عن طريق تسجيل الدخول، واختيار خدمة شهادة المنشأ، وتقديم طلبك من خلال جهازك.",
				"contact": "واتساب: (+971) 800 242 6237؛ الرقم المجاني داخل الإمارات: 800 242 6237 (800 CHAMBER)؛ دولي: (+971) 4 228 0000. تتوفر خدمة المحادثة على مدار الساعة وبريد إلكتروني للاستفسارات عبر موقع غرف دبي.",
				"location": "تُقدَّم الخدمة عبر الإنترنت من خلال بوابة خدمات غرف دبي وتطبيق الهاتف المتحرك، مع توفير دعم إضافي عبر قنوات خدمة المتعاملين ومراكز سعادة المتعاملين."
			},
			"howToApply": [
				"افتح صفحة خدمة «إصدار شهادة منشأ» على موقع غرف دبي واضغط على \"بدء الخدمة\".",
				"سجّل الدخول أو أنشئ حسابًا جديدًا، ثم أدخل تفاصيل الشحنة وحمّل المستندات المطلوبة.",
				"قدّم الطلب، وسدّد الرسوم، ثم نزّل شهادة المنشأ بعد الموافقة."
			],
			"resources": [
				{
					"title": "صفحة خدمة إصدار شهادة منشأ",
					"url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin"
				},
				{
					"title": "صفحة خدمة تعديل شهادة منشأ",
					"url": "https://www.dubaichambers.com/en/amendment-of-certificate-of-origin"
				},
				{
					"title": "صفحة خدمة نظام الأفضليات المعمم (GSP)",
					"url": "https://www.dubaichambers.com/en/generalised-system-of-preferences"
				}
			]
		},
		{
			SRType: 'Certificate Of Origin||COO Bulk Upload',
			"serviceNameForList": "SR_COO_BULK_UPLOAD",
			id: 'coo-bulk-upload',
			"sequence": 1,
			"PreText": "تتيح هذه الخدمة للمستخدمين رفع نموذج مجمع لشهادات المنشأ، وإنشاء طلبات متعددة لشهادات المنشأ في حالة مسودة.",
			"serviceName": "تحميل مجموعات شهادات المنشأ",
			"serviceNameKey": "ISSUE_NEW_COO",
			"organization": "Certificate Of Origin",
			"parentServiceKey": "COO",
			"accessFlagKey": "DC COO Services Flag",
			"url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin",
			"serviceDetail": {
				"description": "تتيح هذه الخدمة للمستخدمين رفع نموذج مجمع لشهادات المنشأ (COO)، وإنشاء طلبات متعددة لإصدار شهادات المنشأ بصفة مسودة. ويمكن للمستخدمين بعد ذلك رفع المستندات الداعمة المطلوبة لكل طلب خدمة على حدة، ومن ثم تقديمها للمراجعة. وتُعد شهادة المنشأ وثيقة رسمية تُثبت منشأ السلع المُصدَّرة أو المُعاد تصديرها، كما تدعم الامتثال للوائح الجمركية والمتطلبات التعريفية.",
				"processingTime": "ساعتان",
				"feesNote": "AED 100"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على \"بدء الخدمة\" لتسجيل الدخول أو التسجيل في منصة خدمات غرف دبي، أو افتح الخدمة من خلال تطبيق غرف دبي على الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "أكمِل النموذج الإلكتروني وحمّل جميع الوثائق المطلوبة المتعلقة بالشحنة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل شهادة المنشأ."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية لإصدار شهادة منشأ:",
				"list": [
					{
						"title": "المستند الأساسي",
						"description": "شحنة مباشرة",
						"documents": [
							{
								"title": "الفاتورة"
							},
							{
								"title": "بوليصة الشحن"
							}
						]
					},
					{
						"title": "منشأ الإمارات",
						"description": "بوليصة الشحن عند إرسال الشحنة مباشرة إلى بلد المقصد.",
						"documents": [
							{
								"title": "نسخة من الرخصة الصناعية"
							},
							{
								"title": "نسخة من فاتورة المصنع"
							}
						]
					},
					{
						"title": "بضائع ترانزيت",
						"description": "نسخة من بيان الترانزيت من جمارك دبي",
						"documents": [
							{
								"title": "نسخة من بيان الترانزيت من جمارك دبي"
							}
						]
					},
					{
						"title": "يرجى العلم بأن غرف دبي تحتفظ بحقها في طلب أي مستندات داعمة إضافية إذا لزم الأمر، بما في ذلك:",
						"description": "نسخة من بيان الترانزيت من جمارك دبي",
						"documents": [
							{
								"title": "قائمة التعبئة"
							},
							{
								"title": "فواتير بلد التصدير"
							},
							{
								"title": "فاتورة بلد المصدّر"
							}
						]
					}
				]
			},
			"serviceFees": [
				{
					"title": "رسوم الخدمة",
					"list": [
						"إصدار شهادة منشأ: AED 100.",
						"AED 5 عن كل صفحة إضافية بعد الصفحة الخامسة من الفاتورة التجارية.",
						"AED 5 عن كل صفحة من صفحات قائمة التعبئة."
					]
				}
			],
			"additionalInformation": {
				"otherChannels": "يمكنك أيضًا التقديم من خلال تطبيق غرف دبي للهواتف المتحركة عن طريق تسجيل الدخول، واختيار خدمة شهادة المنشأ، وتقديم طلبك من خلال جهازك.",
				"contact": "واتساب: (+971) 800 242 6237؛ الرقم المجاني داخل الإمارات: 800 242 6237 (800 CHAMBER)؛ دولي: (+971) 4 228 0000. تتوفر خدمة المحادثة على مدار الساعة وبريد إلكتروني للاستفسارات عبر موقع غرف دبي.",
				"location": "تُقدَّم الخدمة عبر الإنترنت من خلال بوابة خدمات غرف دبي وتطبيق الهاتف المتحرك، مع توفير دعم إضافي عبر قنوات خدمة المتعاملين ومراكز سعادة المتعاملين."
			},
			"howToApply": [
				"افتح صفحة خدمة «إصدار شهادة منشأ» على موقع غرف دبي واضغط على \"بدء الخدمة\".",
				"سجّل الدخول أو أنشئ حسابًا جديدًا، ثم أدخل تفاصيل الشحنة وحمّل المستندات المطلوبة.",
				"قدّم الطلب، وسدّد الرسوم، ثم نزّل شهادة المنشأ بعد الموافقة."
			],
			"resources": [
				{
					"title": "صفحة خدمة إصدار شهادة منشأ",
					"url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin"
				},
				{
					"title": "صفحة خدمة تعديل شهادة منشأ",
					"url": "https://www.dubaichambers.com/en/amendment-of-certificate-of-origin"
				},
				{
					"title": "صفحة خدمة نظام الأفضليات المعمم (GSP)",
					"url": "https://www.dubaichambers.com/en/generalised-system-of-preferences"
				}
			]
		},

		{
			"SRType": "Certificate Of Origin||Amendment",
			"serviceNameForList": "SR_AMD_COO",
			"id": "coo-amendment",
			"sequence": 4,
			"PreText": "تعديل/تصحيح شهادة منشأ صادرة",
			"serviceName": "تعديل شهادة المنشأ",
			"serviceNameKey": "AMENDMENT_COO",
			"organization": "Certificate Of Origin",
			"parentServiceKey": "COO",
			"accessFlagKey": "DC COO Services Flag",
			"url": "https://www.dubaichambers.com/en/amendment-of-certificate-of-origin",
			"serviceDetail": {
				"description": "تتيح لك هذه الخدمة تعديل شهادة منشأ قائمة، وهي وثيقة أساسية لتصدير البضائع. من خلال تحديث الشهادة، تحافظ على الامتثال للوائح الجمركية وتضمن دقة مستنداتك التجارية، التي يجب أن تُرفَق بفاتورة تجارية مفصلة.",
				"processingTime": "ساعتان",
				"feesNote": "AED 50"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على \"بدء الخدمة\" لتسجيل الدخول أو التسجيل في منصة خدمات غرف دبي، أو افتح الخدمة من خلال تطبيق غرف دبي على الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "أكمِل النموذج الإلكتروني وحمّل جميع الوثائق المطلوبة المتعلقة بالشحنة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل الشهادة."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية للتقدم لهذه الخدمة:",
				"list": [
					{
						"title": "المستند الأساسي",
						"description": "شحنة مباشرة",
						"documents": [
							{
								"title": "الفاتورة التجارية المعدَّلة أو أي مستند تم تعديله."
							}
						]
					}
				]
			},
			"serviceFees": [
				{
					"title": "رسوم الخدمة",
					"list": [
						"إصدار شهادة منشأ: AED 100.",
						"AED 5 عن كل صفحة إضافية بعد الصفحة الخامسة من الفاتورة التجارية.",
						"AED 5 عن كل صفحة من صفحات قائمة التعبئة."
					]
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة تعديل شهادة منشأ",
					"url": "https://www.dubaichambers.com/en/amendment-of-certificate-of-origin"
				},
				{
					"title": "صفحة خدمة إصدار شهادة منشأ",
					"url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin"
				},
				{
					"title": "صفحة خدمة إصدار شهادة منشأ للأغراض الشخصية",
					"url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin-for-personal-effect"
				}
			]
		},

		{
			"SRType": "Certificate Of Origin||Personal Effects",
			"serviceNameForList": "SR_PERSONAL_COO",
			"id": "coo-personal-effect",
			"sequence": 6,
			"PreText": "طلب إصدار شهادة منشأ لنقل الأغراض الشخصية إلى بلدك",
			"serviceName": "إصدار شهادة منشأ للأغراض الشخصية",
			"serviceNameKey": "PERSONAL_EFFECTS_COO",
			"organization": "Certificate Of Origin",
			"parentServiceKey": "COO",
			"accessFlagKey": "DC COO Services Flag",
			"url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin-for-personal-effect",
			"serviceDetail": {
				"description": "تتيح لك هذه الخدمة التقدم بطلب للحصول على شهادة منشأ للأغراض الشخصية، وهي وثيقة أساسية تحدد منشأ مقتنياتك الشخصية عند التصدير. من خلال الحصول على هذه الشهادة، تضمن الامتثال للوائح الجمركية، مما يجعل عملية الشحن الدولية أكثر سلاسة وبدون تعقيدات.",
				"processingTime": "ساعتان",
				"feesNote": "AED 100"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على \"بدء الخدمة\" لتسجيل الدخول أو التسجيل في منصة خدمات غرف دبي، أو افتح الخدمة من خلال تطبيق غرف دبي على الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "اتبع التعليمات لتقديم جميع المستندات المطلوبة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل الشهادة."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن للأفراد التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية للتقدم لهذه الخدمة:",
				"list": [
					{
						"title": "نموذج الأغراض الشخصية المستعملة",
						"documents": []
					},
					{
						"title": "نسخة من جواز السفر أو بطاقة الهوية الإماراتية سارية المفعول",
						"documents": []
					}
				]
			},
			"serviceFees": [
				{
					"title": "رسوم الخدمة",
					"list": [
						"AED 100.",
						"ملاحظة: سيتم احتساب رسوم قدرها AED 5 عن كل صفحة إضافية بعد الصفحة الخامسة من النموذج."
					]
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة إصدار شهادة منشأ للأغراض الشخصية",
					"url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin-for-personal-effect"
				},
				{
					"title": "صفحة خدمة إصدار شهادة منشأ",
					"url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin"
				},
				{
					"title": "صفحة خدمة نظام الأفضليات المعمم (GSP)",
					"url": "https://www.dubaichambers.com/en/generalised-system-of-preferences"
				}
			]
		},

		{
			"SRType": "Certificate Of Origin||Issue GSP Certificate",
			"serviceNameForList": "SR_ISSUE_GSP_CERTIFICATE",
			"id": "issue-gsp-certificate",
			"sequence": 2,
			"serviceName": "نظام الأفضليات المعمم (GSP)",
			"serviceNameKey": "ISSUE_GSP_COO",
			"PreText": "تُصدَر شهادة منشأ وفق نظام GSP لمصدّري الدول النامية للاستفادة من الأفضلية الجمركية في الدول المتقدمة.",
			"organization": "Certificate Of Origin",
			"parentServiceKey": "COO",
			"accessFlagKey": "DC COO Services Flag",
			"url": "https://www.dubaichambers.com/en/generalised-system-of-preferences",
			"serviceDetail": {
				"description": "من خلال كونك عضوًا، تستفيد من مجموعة واسعة من المزايا الحصرية، بما في ذلك سهولة التسجيل، ودعم نمو الأعمال، وفرص التواصل، والإرشاد المتخصص. يمكن لشركات البر الرئيسي والمناطق الحرة التي تمارس أنشطة تجارية أو صناعية أو مهنية التسجيل للحصول على العضوية.",
				"processingTime": "ساعتان",
				"feesNote": "AED 100"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على \"بدء الخدمة\" لتسجيل الدخول أو التسجيل في منصة خدمات غرف دبي، أو افتح الخدمة من خلال تطبيق غرف دبي على الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "أكمِل النموذج الإلكتروني وحمّل جميع الوثائق المطلوبة المتعلقة بالشحنة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل الشهادة."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "يجب أن تستوفي الشحنة المصدَّرة المعايير التالية للاستفادة من خدمة GSP:",
				"list": [
					{
						"title": "منشأ المنتج:",
						"documents": [
							{
								"title": "يجب أن يكون المنتج من منشأ دولة الإمارات العربية المتحدة."
							}
						]
					},
					{
						"title": "بلد الوجهة:",
						"documents": [
							{
								"title": "يجب تصدير الشحنة إلى إحدى الدول المدرجة في الطلب."
							}
						]
					},
					{
						"title": "المستندات:",
						"description": "",
						"documents": [
							{
								"title": "إذا كنت تحمل رخصة صناعية، يجب إرفاق نسخة من الفاتورة التجارية."
							},
							{
								"title": "إذا كنت تحمل رخصة تجارية، يجب إرفاق نسخة من الفاتورة التجارية ونسخة من فاتورة الشراء من مصنع داخل دولة الإمارات."
							}
						]
					}
				]
			},
			"serviceFees": [
				{
					"title": "رسوم الخدمة",
					"list": [
						"AED 100."
					]
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة نظام الأفضليات المعمم (GSP)",
					"url": "https://www.dubaichambers.com/en/generalised-system-of-preferences"
				},
				{
					"title": "صفحة خدمة إصدار شهادة منشأ",
					"url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin"
				},
				{
					"title": "صفحة خدمة إصدار شهادة منشأ للأغراض الشخصية",
					"url": "https://www.dubaichambers.com/en/issuing-a-certificate-of-origin-for-personal-effect"
				}
			]
		},

		{
			"SRType": "Attestation||Authenticate Certificate",
			"serviceNameForList": "SR_AUTHENTICATE_DOCUMENT",
			"id": "attestation-authenticate-document",
			"sequence": 15,
			"PreText": "طلب توثيق الشهادات والمستندات الصادرة عن جهات تابعة لحكومة دبي وتحمل شعار حكومة دبي على الترويسة",
			"serviceName": "خدمات التوثيق",
			"serviceNameKey": "ATTESTATION_AUTH_CERTIFICATE",
			"organization": "Attestation",
			"parentServiceKey": "ATTESTATION",
			"accessFlagKey": "DC SVS Services Flag",
			"serviceDetail": {
				"description": "وثّق مستنداتك الحكومية لضمان الاعتراف الرسمي بها. تسهم هذه الخدمة في تبسيط الإجراءات وتعزيز قبول ومصداقية المستندات الأساسية لأعضائنا.",
				"processingTime": "ساعتان",
				"feesNote": "AED 100"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على «بدء الخدمة» لإنشاء حساب أو لتسجيل الدخول إلى منصة خدمات غرف دبي، أو افتح الخدمة من خلال تطبيق غرف دبي على الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "اتبع التعليمات لتقديم جميع المستندات المطلوبة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل شهادة/مستند التوثيق."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية للتقدم لهذه الخدمة:",
				"list": [
					{
						"title": "المستند المطلوب توثيقه (مصدَّق من الجهة/السلطة المصدرة للمستند)"
					}
				],
				"note": "يرجى العلم بأن غرف دبي تحتفظ بحقها في طلب أي مستندات داعمة إضافية إذا لزم الأمر."
			},
			"serviceFees": [
				{
					"title": "رسوم التوثيق",
					"list": [
						"الحد الأدنى: AED 100."
					],
					"note": "ملاحظة: سيتم احتساب رسوم قدرها AED 10 عن كل نسخة إضافية بعد النسخة الخامسة من المعاملة نفسها."
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة التوثيق",
					"url": "https://www.dubaichambers.com/en/authentication"
				},
				{
					"title": "صفحة خدمة صورة طبق الأصل",
					"url": "https://www.dubaichambers.com/en/true-copy"
				},
				{
					"title": "صفحة خدمة صحة التوقيع",
					"url": "https://www.dubaichambers.com/en/signature-attestation"
				}
			]
		},

		{
			"SRType": "Attestation||True Copy",
			"serviceNameForList": "SR_CERTIFY_DOCUMENT",
			"id": "attestation-certify-document",
			"sequence": 16,
			"serviceName": "صورة طبق الأصل",
			"serviceNameKey": "ATTESTATION_CERTIFY_DOCUMENT",
			"organization": "Attestation",
			"parentServiceKey": "ATTESTATION",
			"accessFlagKey": "DC SVS Services Flag",
			"PreText": "طلب التحقق وتوثيق مستند كصورة طبق الأصل من الأصل",
			"serviceDetail": {
				"description": "حسِّن مصداقية مستنداتك لتسهيل المعاملات والتواصل مع الجهات الرسمية من خلال خدمة تصديق صورة طبق الأصل. نضمن أن مستنداتك تمثل نسخًا مطابقة للأصل، بما يضمن قبولها لدى الجهات المعنية.",
				"processingTime": "ساعتان",
				"feesNote": "AED 100"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على «بدء الخدمة» لإنشاء حساب أو لتسجيل الدخول إلى منصة خدمات غرف دبي، أو الوصول إلى الخدمة من خلال تطبيق غرف دبي على الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "قم برفع المستند المطلوب توثيقه كصورة طبق الأصل وأكمل نموذج الطلب الإلكتروني."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل شهادة التوثيق."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية للتقدم لهذه الخدمة:",
				"list": [
					{
						"title": "المستند المطلوب توثيقه (قم برفع المستند تحت حقل مستند التحقق من التوقيع)",
						"description": ""
					}
				],
				"note": "يرجى العلم بأن غرف دبي تحتفظ بحقها في طلب أي مستندات داعمة إضافية إذا لزم الأمر."
			},
			"serviceFees": [
				{
					"title": "رسوم صورة طبق الأصل",
					"list": [
						"الحد الأدنى: AED 100"
					],
					"note": "ملاحظة: سيتم احتساب رسوم قدرها AED 10 عن كل نسخة إضافية بعد 5 نسخ من المعاملة نفسها."
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة صورة طبق الأصل",
					"url": "https://www.dubaichambers.com/en/true-copy"
				},
				{
					"title": "صفحة خدمة التوثيق",
					"url": "https://www.dubaichambers.com/en/authentication"
				},
				{
					"title": "صفحة خدمة صحة التوقيع",
					"url": "https://www.dubaichambers.com/en/signature-attestation"
				}
			]
		},

		{
			"SRType": "Attestation||Verify Signature",
			"serviceNameForList": "SR_VERIFY_SIGNATURE",
			"id": "attestation-verify-signature",
			"sequence": 17,
			"serviceName": "Signature Verification",
			"serviceNameKey": "ATTESTATION_VERIFY_SIGNATURE",
			"organization": "Attestation",
			"parentServiceKey": "ATTESTATION",
			"accessFlagKey": "DC SVS Services Flag",
			"PreText": "طلب التحقق من التوقيع على المستندات",
			"serviceDetail": {
				"description": "تحقق من صحة توقيع المخوَّل بالتوقيع والمستندات والمراسلات والعقود ذات الصلة، بما يضمن قبولها من قبل الجهات المعنية. تساعد هذه الخدمة أعضائنا في تبسيط الإجراءات وتعزيز مصداقية مستنداتهم الرسمية.",
				"processingTime": "ساعتان",
				"feesNote": "AED 100"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على «بدء الخدمة» لتسجيل الدخول أو التسجيل في منصة خدمات غرف دبي، أو الوصول إلى الخدمة عن طريق تطبيق غرف دبي على الهاتف المتحرك."
				},
				{
					"title": "تقديم الطلب",
					"description": "اتبع التعليمات لتقديم جميع المستندات المطلوبة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، يمكنك تنزيل المستند المصدَّق على توقيعه من البوابة."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية للتقدم لهذه الخدمة:",
				"list": [
					{
						"title": "يجب أن يكون المستند المطلوب توثيقه موقَّعًا من المخوَّل بالتوقيع",
						"description": ""
					}
				],
				"note": "يرجى العلم بأن غرف دبي تحتفظ بحقها في طلب أي مستندات داعمة إضافية إذا لزم الأمر."
			},
			"serviceFees": [
				{
					"title": "رسوم التحقق من التوقيع",
					"list": [
						"AED 100",
						"ملاحظة: سيتم احتساب رسوم قدرها AED 10 عن كل نسخة إضافية بعد النسخة الخامسة من المعاملة نفسها."
					]
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة صورة طبق الأصل",
					"url": "https://www.dubaichambers.com/en/true-copy"
				},
				{
					"title": "صفحة خدمة التوثيق",
					"url": "https://www.dubaichambers.com/en/authentication"
				},
				{
					"title": "صفحة خدمة صحة التوقيع",
					"url": "https://www.dubaichambers.com/en/signature-attestation"
				}
			]
		},

		{
			"SRType": "ATA Carnet||Issue New Carnet",
			"serviceNameForList": "SR_ATA_CARNET_NEW",
			"id": "ata-carnet-registration",
			"sequence": 7,
			"PreText": "طلب إصدار دفتر إدخال مؤقت جديد يسمح لحامله بتصدير البضائع مؤقتاً إلى دولة أو عدة دول ضمن نظام الادخال المؤقت",
			//"PreText": "طلب إصدار دفتر إدخال مؤقت جديد يسمح لحامله بتصدير بضائع مؤقتًا إلى دولة أو عدة دول ضمن نظام الكارنيه.",
			"serviceName": "إصدار دفتر الإدخال المؤقت (ATA Carnet)",
			"serviceNameKey": "ISSUE_NEW_CARNET",
			"organization": "ATA Carnet",
			"parentServiceKey": "ATA_CARNET",
			"accessFlagKey": "DC ATA Carnet Flag",
			"serviceDetail": {
				"description": "قدِّم طلبًا للحصول على مستند جمركي دولي يسمح لك باستيراد/تصدير البضائع مؤقتًا دون دفع الرسوم أو الضرائب لمدة تصل إلى سنة واحدة. يسهّل هذا المستند نقل منتجاتك عبر الحدود للمشاركة في المعارض والفعاليات التجارية وغيرها من الأغراض المؤقتة، مما يضمن أنشطة أعمال دولية ميسّرة وفعّالة من حيث التكلفة.",
				"processingTime": "1-2 يوم عمل",
				"feesNote": "AED 900 - AED 2,300"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على \"بدء الخدمة\" لتسجيل الدخول أو إنشاء حساب جديد على منصة خدمات غرف دبي."
				},
				{
					"title": "تقديم الطلب",
					"description": "قم بتعبئة نموذج طلب دفتر الإدخال المؤقت وتحميل المستندات المطلوبة الخاصة بالشحنة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال يومي عمل من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل المستندات الخاصة بك."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي وغير الأعضاء التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية للتقدم لهذه الخدمة:",
				"list": [
					{
						"title": "الفاتورة التجارية",
						"description": ""
					},
					{
						"title": "رسالة تفويض صادرة من الشركة لممثليها أو وكلائها",
						"description": ""
					},
					{
						"title": "يرجى العلم بأن غرف دبي تحتفظ بحقها في طلب أي مستندات داعمة إضافية إذا لزم الأمر",
						"description": ""
					}
				]
			},
			"serviceFees": [
				{
					"title": "رسوم معالجة دفتر الإدخال المؤقت (صالحة لزيارة واحدة)",
					"list": [
						"الأعضاء - AED 900",
						"غير الأعضاء - AED 1,800"
					]
				},
				{
					"title": "رسوم معالجة دفتر الإدخال المؤقت المستعجل (صالح لزيارة دولة واحدة)",
					"list": [
						"الأعضاء - AED 1,400",
						"غير الأعضاء - AED 2,300"
					]
				},
				{
					"title": "الدول الإضافية",
					"list": [
						"الأعضاء - AED 50 عن كل دولة",
						"غير الأعضاء - AED 100 عن كل دولة"
					]
				},
				{
					"title": "الصفحات الإضافية للقائمة العامة",
					"list": [
						"الأعضاء - AED 5 عن كل دولة",
						"غير الأعضاء - AED 10 عن كل دولة"
					]
				},
				{
					"title": "التسوية",
					"list": [
						"الأعضاء - AED 300",
						"غير الأعضاء - AED 600"
					]
				},
				{
					"title": "مبلغ الضمان",
					"list": [
						"تُحتسب رسوم الضمان بناءً على القيمة الإجمالية للبضائع والرسوم الجمركية (حسب جدول نسب ضمان دفتر الإدخال المؤقت) في الدول المراد زيارتها، ويتم ردّها بعد إقفال الدفتر أصولاً.",
						"ملاحظة: قد يختلف إجمالي مبلغ رسوم الخدمة حسب متطلباتك المحددة."
					]
				},
				{
					"title": "ملاحظات:",
					"list": [
						"احتساب مبلغ الضمان = (إجمالي قيمة الفاتورة * إجمالي الضريبة/100)",
						"إذا كانت العملة غير AED، يرجى تحويل قيمة الفاتورة إلى AED قبل إجراء الحساب.",
						"سيتم مشاركة المبلغ النهائي للضمان عند تقديم طلب الخدمة.",
						"في حال تعدد الوجهات، يُحتسب الضمان بناءً على الدولة ذات النسبة الأعلى."
					]
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة إصدار دفتر الإدخال المؤقت",
					"url": "https://www.dubaichambers.com/en/issuance-of-ata-carnet"
				},
				{
					"title": "دليل الخدمات – خدمات غرف دبي",
					"url": "https://www.dubaichambercommerce.com/documents/20119/0/Service_Manual_En.pdf"
				}
			]
		},

		{
			"SRType": "ATA Carnet||Substitute Carnet",
			"serviceNameForList": "SR_ATA_CARNET_SUBS",
			"id": "ata-carnet-substitute",
			"sequence": 10,
			"PreText": "طلب إصدار دفتر إدخال مؤقت بدل فاقد في حالة فقدان الدفتر الأصلي",
			"serviceName": "دفتر إدخال مؤقت بدل فاقد",
			"serviceNameKey": "SUBSTITUTE_CARNET",
			"organization": "ATA Carnet",
			"parentServiceKey": "ATA_CARNET",
			"accessFlagKey": "DC ATA Carnet Flag",
			"serviceDetail": {
				"description": "إذا فُقد دفتر الإدخال المؤقت الخاص بك أو تعرّض للتلف أو التلف الجزئي، فمن المهم الحصول على دفتر إدخال مؤقت بدل فاقد لمواصلة الأنشطة التجارية الدولية دون انقطاع. يُعد هذا المستند ضروريًا لدخول أو مغادرة الدول الأجنبية وإعادة الدخول إلى دولة الإمارات، حيث يسمح بالاستيراد المؤقت للبضائع دون دفع الرسوم أو الضرائب لمدة تصل إلى سنة واحدة.",
				"processingTime": "يوم عمل واحد",
				"feesNote": "AED 900 - AED 1,800"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على \"بدء الخدمة\" لتسجيل الدخول أو إنشاء حساب جديد على منصة خدمات غرف دبي."
				},
				{
					"title": "تقديم الطلب",
					"description": "قم بتعبئة نموذج طلب دفتر الإدخال المؤقت وتحميل المستندات المطلوبة الخاصة بالشحنة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال يومي عمل من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل المستندات الخاصة بك."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي وغير الأعضاء التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "لا توجد متطلبات وثائقية للتقدم لهذه الخدمة.",
				"list": []
			},
			"serviceFees": [
				{
					"title": "الرسوم للأعضاء وغير الأعضاء:",
					"list": [
						"الأعضاء - AED 900",
						"غير الأعضاء - AED 1,800"
					]
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة دفتر إدخال مؤقت بدل فاقد",
					"url": "https://www.dubaichambers.com/en/substitute-of-lost-ata-carnet"
				},
				{
					"title": "صفحة خدمة إصدار دفتر الإدخال المؤقت",
					"url": "https://www.dubaichambers.com/en/issuance-of-ata-carnet"
				}
			]
		},

		{
			"SRType": "ATA Carnet||Amendment Carnet",
			"serviceNameForList": "SR_ATA_CARNET_AMD",
			"id": "ata-carnet-amendment",
			"sequence": 8,
			"PreText": "تعديل/تصحيح دفتر إدخال مؤقت صادر",
			"serviceName": "تعديل دفتر الإدخال المؤقت",
			"serviceNameKey": "AMENDMENT_CARNET",
			"organization": "ATA Carnet",
			"parentServiceKey": "ATA_CARNET",
			"accessFlagKey": "DC ATA Carnet Flag",
			"serviceDetail": {
				"description": "قدِّم طلبًا لتعديل دفتر الإدخال المؤقت لاستيراد البضائع مؤقتًا دون رسوم أو ضرائب لمدة تصل إلى سنة واحدة. يسهّل ذلك نقل المنتجات عبر الحدود للمشاركة في المعارض والفعاليات التجارية والأغراض المؤقتة الأخرى. حافظ على تحديث بيانات الدفتر لضمان سير أنشطتك التجارية الدولية بسلاسة وبشكل فعّال من حيث التكلفة.",
				"processingTime": "يوم عمل واحد",
				"feesNote": "AED 100 - AED 200"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على \"بدء الخدمة\" لتسجيل الدخول أو إنشاء حساب جديد على منصة خدمات غرف دبي."
				},
				{
					"title": "تقديم الطلب",
					"description": "قم بتعبئة نموذج طلب دفتر الإدخال المؤقت وتحميل المستندات المطلوبة الخاصة بالشحنة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال يومي عمل من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل المستندات الخاصة بك."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي وغير الأعضاء التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية للتقدم لهذه الخدمة:",
				"list": [
					{
						"title": "فاتورة تجارية معدّلة",
						"description": ""
					},
					{
						"title": "رسالة تفويض معدّلة صادرة من الشركة لممثليها أو وكلائها",
						"description": ""
					},
					{
						"title": "يرجى العلم بأن غرف دبي تحتفظ بحقها في طلب أي مستندات داعمة إضافية إذا لزم الأمر",
						"description": ""
					}
				]
			},
			"serviceFees": [
				{
					"title": "الرسوم للأعضاء وغير الأعضاء:",
					"list": [
						"الأعضاء - AED 100",
						"غير الأعضاء - AED 200",
						"ملاحظة: قد تختلف الرسوم بناءً على تفاصيل الطلب."
					]
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة تعديل دفتر الإدخال المؤقت",
					"url": "https://www.dubaichambers.com/en/modification-of-ata-carnet"
				},
				{
					"title": "صفحة خدمة إصدار دفتر الإدخال المؤقت",
					"url": "https://www.dubaichambers.com/en/issuance-of-ata-carnet"
				}
			]
		},

		{
			"SRType": "ATA Carnet||Replacement Carnet",
			"serviceNameForList": "SR_ATA_CARNET_REPLACE",
			"id": "ata-carnet-replace",
			"sequence": 11,
			"serviceName": "دفتر إدخال مؤقت بديل",
			"serviceNameKey": "REPLACE_CARNET",
			"organization": "ATA Carnet",
			"parentServiceKey": "ATA_CARNET",
			"accessFlagKey": "DC ATA Carnet Flag",
			"PreText": "طلب إصدار دفتر جديد ليحل محل دفتر إدخال مؤقت أصلي يوشك على الانتهاء، مع تمديد الصلاحية لمدة 12 شهرًا أخرى",
			"serviceDetail": {
				"description": "إذا كان دفتر الإدخال المؤقت الأصلي الخاص بك على وشك الانتهاء وتحتاج إلى المزيد من الوقت لاستيراد/تصدير البضائع مؤقتًا دون دفع الرسوم أو الضرائب، يمكنك التقدم بطلب للحصول على دفتر إدخال مؤقت بديل. يسهّل هذا المستند الأنشطة عبر الحدود للمشاركة في المعارض والفعاليات التجارية والأغراض المؤقتة الأخرى، مما يساهم في تسيير الأعمال الدولية بسلاسة وبشكل فعّال من حيث التكلفة.",
				"processingTime": "يوم عمل واحد",
				"feesNote": "AED 900 - AED 1,800"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على \"بدء الخدمة\" لتسجيل الدخول أو إنشاء حساب جديد على منصة خدمات غرف دبي."
				},
				{
					"title": "تقديم الطلب",
					"description": "قم بتعبئة نموذج طلب دفتر الإدخال المؤقت وتحميل المستندات المطلوبة الخاصة بالشحنة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال يومي عمل من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل المستندات الخاصة بك."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي وغير الأعضاء التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "لا توجد متطلبات وثائقية للتقدم لهذه الخدمة.",
				"list": []
			},
			"serviceFees": [
				{
					"title": "الرسوم للأعضاء وغير الأعضاء:",
					"list": [
						"الأعضاء - AED 900",
						"غير الأعضاء - AED 1,800"
					]
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة استبدال دفتر الإدخال المؤقت",
					"url": "https://www.dubaichambers.com/en/replacement-of-ata-carnet"
				},
				{
					"title": "صفحة خدمة إصدار دفتر الإدخال المؤقت",
					"url": "https://www.dubaichambers.com/en/issuance-of-ata-carnet"
				}
			]
		},

		{
			"SRType": "ATA Carnet||Refund",
			"serviceNameForList": "SR_ATA_CARNET_REFUND",
			"id": "ata-carnet-refund",
			"sequence": 13,
			"serviceName": "استرداد دفتر الإدخال المؤقت",
			"serviceNameKey": "REFUND_CARNET",
			"organization": "ATA Carnet",
			"parentServiceKey": "ATA_CARNET",
			"accessFlagKey": "DC ATA Carnet Flag",
			"PreText": "يرجى تسليم النسخة الأصلية من دفتر الإدخال المؤقت قبل تقديم الطلب.",
			"serviceDetail": {
				"description": "من المهم إعادة دفتر الإدخال المؤقت عندما لا تكون بحاجة إليه لتجنب المشكلات الجمركية ومنع إساءة الاستخدام. يضمن ذلك الامتثال للوائح، وإنهاء امتيازات الإدخال المؤقت، والحفاظ على توثيق صحيح، وتفادي الرسوم أو الضرائب الجمركية.",
				"processingTime": "يوم عمل واحد",
				"feesNote": "لا يتم استرداد رسوم المعالجة"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على \"بدء الخدمة\" لتسجيل الدخول أو إنشاء حساب جديد على منصة خدمات غرف دبي."
				},
				{
					"title": "تقديم الطلب",
					"description": "قم بتعبئة نموذج طلب دفتر الإدخال المؤقت وتحميل المستندات المطلوبة الخاصة بالشحنة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال يومي عمل من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل المستندات الخاصة بك."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي وغير الأعضاء التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية للتقدم لهذه الخدمة:",
				"list": [
					{
						"title": "شهادة تسجيل ضريبة القيمة المضافة"
					},
					{
						"title": "الرخصة التجارية"
					},
					{
						"title": "تفاصيل حساب الشركة – على ورق رسمي من البنك"
					},
					{
						"title": "نسخة ممسوحة ضوئيًا من دفتر الإدخال المؤقت"
					},
					{
						"title": "ملاحظة: سيتم البدء في استرداد مبلغ الضمان بعد تسليم دفتر الإدخال المؤقت الأصلي."
					}
				]
			},
			"serviceFees": [
				{
					"title": "رسوم الخدمات",
					"list": [
						"الأعضاء - لا يتم استرداد رسوم المعالجة",
						"غير الأعضاء - لا يتم استرداد رسوم المعالجة"
					]
				},
				{
					"title": "مبلغ الضمان",
					"list": [
						"تُحتسب رسوم الضمان بناءً على القيمة الإجمالية للبضائع والرسوم الجمركية (حسب جدول نسب ضمان دفتر الإدخال المؤقت) في الدول المراد زيارتها، ويتم ردّها بعد إقفال الدفتر أصولاً."
					]
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة استرداد دفتر الإدخال المؤقت",
					"url": "https://www.dubaichambers.com/en/refund-of-ata-carnet"
				},
				{
					"title": "صفحة خدمة إصدار دفتر الإدخال المؤقت",
					"url": "https://www.dubaichambers.com/en/issuance-of-ata-carnet"
				}
			]
		},

		{
			"SRType": "ATA Carnet||NOC Letter Request",
			"serviceNameForList": "SR_ATA_CARNET_NOC",
			"id": "ata-carnet-noc-letter",
			"sequence": 14,
			"serviceName": "طلب رسالة عدم ممانعة",
			"serviceNameKey": "NOC_LETTER_CARNET",
			"organization": "ATA Carnet",
			"parentServiceKey": "ATA_CARNET",
			"accessFlagKey": "DC ATA Carnet Flag",
			"serviceDetail": {
				"description": "طلب إصدار شهادة عدم ممانعة (NOC) بناءً على طلب الجمارك المحلية.",
				"processingTime": "يوم عمل واحد",
				"feesNote": "AED 100"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على \"بدء الخدمة\" لتسجيل الدخول أو إنشاء حساب جديد على منصة خدمات غرف دبي."
				},
				{
					"title": "تقديم الطلب",
					"description": "قم بتعبئة نموذج طلب دفتر الإدخال المؤقت وتحميل المستندات المطلوبة الخاصة بالشحنة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال يومي عمل من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل المستندات الخاصة بك."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي وغير الأعضاء التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "يرجى ملاحظة أنه إذا كان نوع الدفتر «محلي»، فإن الصفحة الأولى فقط من النموذج مطلوبة. يرجى التأكد من توفر المتطلبات التالية للاستفادة من الخدمة:",
				"list": [
					{
						"title": "النسخة الأصلية من الدفتر"
					},
					{
						"title": "خطاب طلب"
					}
				]
			},
			"serviceFees": [
				{
					"title": "رسوم الخدمة",
					"list": [
						"AED 100"
					]
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة استرداد دفتر الإدخال المؤقت",
					"url": "https://www.dubaichambers.com/en/refund-of-ata-carnet"
				},
				{
					"title": "صفحة خدمة إصدار دفتر الإدخال المؤقت",
					"url": "https://www.dubaichambers.com/en/issuance-of-ata-carnet"
				}
			]
		},

		{
			"SRType": "Mediation Services||Mediation",
			"serviceNameForList": "SR_MEDIATION",
			"id": "mediation",
			"sequence": 23,
			"serviceName": "الوساطة",
			"serviceNameKey": "MEDIATION",
			"organization": "Mediation Services",
			"parentServiceKey": "MEDIATION_SERVICES",
			"accessFlagKey": "DC Legal Services Flag",
			"PreText": "طلب وساطة لتسوية المنازعات التجارية وديًا",
			"serviceDetail": {
				"description": "قم بحل النزاعات التجارية بسرعة وبشكل ودي من خلال خدمة الوساطة لدينا. استفد من عملية سرّية وفعّالة من حيث التكلفة تساعدك على تجنب التقاضي الطويل والمكلف. يساعد الوسطاء المتخصصون في تسهيل المفاوضات للوصول إلى حل متفق عليه بين الأطراف بمرونة وسهولة. تعتبر الوساطة من أكثر أساليب تسوية المنازعات البديلة فعالية.",
				"processingTime": "6 أيام",
				"feesNote": "من AED 500 إلى AED 1,000"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على «بدء الخدمة» لإنشاء حسابك أو لتسجيل الدخول إلى منصة خدمات غرف دبي."
				},
				{
					"title": "تقديم الطلب",
					"description": "اتبع التعليمات لتقديم جميع المعلومات والمستندات الداعمة المتعلقة بالنزاع."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، تتواصل غرفة تجارة دبي مع الأطراف المعنية للوصول إلى تسوية مناسبة حسب طبيعة النزاع."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي وغير الأعضاء التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات للتقدم لهذه الخدمة:",
				"list": [
					{
						"title": "إرفاق مستند داعم واحد على الأقل مثل فاتورة أو أمر شراء محلي أو مذكرة تسليم أو بوليصة شحن أو عقد",
						"documents": [
							{
								"title": "الفواتير"
							},
							{
								"title": "أوامر الشراء (LPOs)"
							},
							{
								"title": "مذكرات التسليم"
							},
							{
								"title": "المراسلات"
							},
							{
								"title": "الاتفاقية/العقد"
							},
							{
								"title": "مذكرات التسليم"
							},
							{
								"title": "كشف حساب"
							},
							{
								"title": "عرض سعر"
							},
							{
								"title": "كشف حساب"
							},
							{
								"title": "خطاب اعتماد"
							},
							{
								"title": "بوليصة الشحن"
							}
						]
					},
					{
						"title": "مستندات أخرى",
						"documents": [
							{
								"title": "خطاب تفويض/وكالة قانونية لتقديم الشكوى أمام غرفة دبي (ينطبق ذلك على مكاتب المحاماة فقط)"
							},
							{
								"title": "رخصة المتقدّم بالشكوى (إلزامية)"
							},
							{
								"title": "مستند تعيين المدير/الممثل (إن وجد)"
							},
							{
								"title": "نسخة من شهادة العضوية (إن وجدت)"
							}
						]
					}
				]
			},
			"serviceFees": [
				{
					"title": "رسوم تسجيل الوساطة",
					"list": [
						"الأعضاء - AED 500  غير الأعضاء - AED 1,000"
					]
				},
				{
					"title": "رسوم إدارة الوساطة",
					"list": [
						"الأعضاء - 1% من قيمة النزاع، بحد أدنى AED 500 وبحد أقصى AED 15,000",
						"غير الأعضاء – 2% من قيمة النزاع، بحد أدنى AED 1,000 وبحد أقصى AED 20,000"
					]
				},
				{
					"title": "ضريبة القيمة المضافة: 5%",
					"list": [
						"الرسوم المذكورة أعلاه والضريبة غير قابلة للاسترداد ويجب دفعها مقدمًا للبدء بإجراءات الوساطة."
					]
				},
				{
					"title": "قد يختلف إجمالي مبلغ رسوم الخدمة حسب متطلباتك المحددة."
				}
			],
			"Sector": "Business",
			"serviceType": "Sub-service - Informational",
			"resources": [
				{
					"title": "صفحة خدمة الوساطة",
					"url": "https://www.dubaichambers.com/en/mediation"
				}
			]
		},

		{
			"SRType": "Information Services||Information Services",
			"serviceNameForList": "SR_INFORMATION_SERVICE",
			"id": "information-service",
			"sequence": 27,
			"serviceName":"خدمة المعلومات والشهادات",
			"serviceNameKey": "INFORMATION_SERVICES",
			"organization": "Information Services",
			"parentServiceKey": "INFORMATION_AND_CERTIFICATES_SERVICES",
			"accessFlagKey": "DC Information Services Flag",
			"PreText":"خدمة متاحة لطلب مستندات أساسية مثل بيانات المنشأة  وشهادات لمن يهمه الأمر", //"توفِّر هذه الخدمة رسائل «لمن يهمه الأمر» وشهادات التزكية والتعريف، وقنوات إصدار بيانات المنشأة.",
			"serviceDetail": {
				"description": "تحقق من صحة المخوَّل بالتوقيع والمستندات والمراسلات والعقود ذات الصلة، بما يضمن قبولها من الجهات المعنية. تساعد هذه الخدمة أعضائنا في تبسيط الإجراءات وتعزيز مصداقية مستنداتهم الرسمية.",
				"processingTime": "ساعتان",
				"feesNote": "AED 210"
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى منصة الخدمات",
					"description": "اضغط على «بدء الخدمة» لإنشاء حسابك أو لتسجيل الدخول إلى منصة خدمات غرف دبي."
				},
				{
					"title": "تقديم الطلب",
					"description": "قم بتقديم طلب إصدار الرسالة أو الشهادة المطلوبة عبر الموقع الإلكتروني، مع إدخال جميع المعلومات اللازمة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك واعتماده خلال ساعتين من وقت التقديم إذا استوفيت جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيتم توجيهك لتنزيل المستندات الخاصة بك."
				}
			],
			"Beneficiaries": [
				{
					"title": "المستفيدون",
					"description": "يمكن لأعضاء غرفة تجارة دبي التقدم لهذه الخدمة."
				}
			],
			"serviceRequirements": {
				"title": "فيما يلي المتطلبات الوثائقية للتقدم لهذه الخدمة:",
				"list": [
					{
						"title": "رسالة طلب من الشركة موقّعة ومختومة من المفوض بالتوقيع لدى غرف دبي"
					}
				]
			},
			"serviceFees": [
				{
					"title": "رسوم الرسائل والشهادات",
					"list": [
						"رسالة «لمن يهمه الأمر»: AED 210"
					]
				},
				{
					"title": "رسوم بيانات المنشأة",
					"list": [
						"بيانات المنشأة: AED 52.50"
					]
				}
			],
			"resources": [
				{
					"title": "صفحة خدمة الرسائل والشهادات",
					"url": "https://www.dubaichambers.com/en/letters-and-certificates"
				},
				{
					"title": "بيانات المنشأة – خدمة ذات صلة",
					"url": "https://www.dubaichambers.com/en/company-profile"
				}
			]
		},
		{
			"SRType": "Mystery Shopper Membership||Mystery Shopper Membership",
			"serviceNameForList": "SR_MYSTERY_SHOPPER_MEMBERSHIP",
			"id": 'mystery-shopper',
			"sequence": 27,
			"serviceName": "عضوية المتسوق السري",
			"organization": "Mystery Shopper Membership",
			"parentServiceKey": "SERVICE_EXCELLENCE_PROGRAMME",
			"serviceNameKey": "MYSTERY_SHOPPER_MEMBERSHIP",
			"PreText": "",
			"serviceDetail": {
				"description": "",
				"processingTime": "",
				"feesNote": "",
				"otherDetail": {
					"greeting": "عزيزنا العضو الكريم،",
					"intro": "فيما يلي باقات العضوية التي يمكنك اختيارها أثناء تقديم الطلب:",
					"titile": "الباقات:",
					"list": [
						{
							"title": "<b>الباقة 1:</b> تشمل زيارتين لكل فرع في كل ربع سنة."
						},
						{
							"title": "<b>الباقة 2:</b> تشمل ثلاث زيارات لكل فرع في كل ربع سنة."
						},
						{
							"title": "<b>الباقة 3:</b> تشمل تقييمين افتراضيين لكل قناة في كل ربع سنة."
						},
						{
							"title": "<b>الباقة 4:</b> تشمل زيارة واحدة لكل فرع في كل ربع سنة."
						},
						{
							"title": "<b>الباقة 5:</b> تشمل تقييماً افتراضياً واحداً لكل قناة في كل ربع سنة."
						},
						{
							"title": "<b>حقيبة الهوية</b>: لكل علامة تجارية (وليس لكل فرع)."
						}
					]
				}
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى بوابة الخدمات",
					"description": "انقر على «بدء الخدمة» لإنشاء حسابك أو تسجيل الدخول إلى بوابة خدمات غرف دبي."
				},
				{
					"title": "تقديم الطلب",
					"description": "قم بتقديم الشهادة أو الخطاب المطلوب عبر الموقع الإلكتروني وتزويد جميع المعلومات المطلوبة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك والموافقة عليه خلال ساعتين من التقديم في حال استيفاء جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيُطلب منك تنزيل المستندات الخاصة بك."
				}
			],

			"serviceFees": [
				{
					"title": "قد تختلف الرسوم بناءً على تفاصيل الطلب."
				}
			]
		},
		{
			"SRType": "MRM Awards||MRM Awards",
			"serviceNameForList": "SR_MRM_AWARDS",
			"id": 'mrm-award',
			"sequence": 27,
			"serviceName": "جوائز MRM",
			"organization": "MRM Awards",
			"PreText": "",
			"parentServiceKey": "MRM_AWARDS",
			"serviceNameKey": "MRM_APPLICATION",
			"serviceDetail": {
				"description": "",
				"processingTime": "",
				"feesNote": "",
				"otherDetail": {
					"greeting": "عزيزنا العضو الكريم،",
					"intro": "سيختار المتقدمون فئة الجائزة التي يرغبون في التقديم الرسمي لها."
				},
			},
			"serviceProcedure": [
				{
					"title": "الدخول إلى بوابة الخدمات",
					"description": "انقر على «بدء الخدمة» لإنشاء حسابك أو تسجيل الدخول إلى بوابة خدمات غرف دبي."
				},
				{
					"title": "تقديم الطلب",
					"description": "قم بتقديم الشهادة أو الخطاب المطلوب عبر الموقع الإلكتروني وتزويد جميع المعلومات المطلوبة."
				},
				{
					"title": "عملية الموافقة",
					"description": "سيتم مراجعة طلبك والموافقة عليه خلال ساعتين من التقديم في حال استيفاء جميع المتطلبات."
				},
				{
					"title": "الدفع والتأكيد",
					"description": "بعد سداد الرسوم، سيُطلب منك تنزيل المستندات الخاصة بك."
				}
			],
			"serviceFees": [
				{
					"title": "قد تختلف الرسوم بناءً على تفاصيل الطلب."
				},
				{
					"title": "رسوم تدريب الطلب:",
					"list": [
						"عضو غرفة دبي: 2500 درهم إماراتي لكل مشارك",
						"غير عضو: 3000 درهم إماراتي لكل مشارك"
					]
				},
				{
					"title": "رسوم التقديم:",
					"list": [
						"عضو غرفة دبي: 3000 درهم إماراتي",
						"غير عضو: 3500 درهم إماراتي"
					]
				},
				{
					"title": "*ملاحظة: تطبق رسوم ضريبة القيمة المضافة."
				}
			]
		},
		// {
		// 	"SRType": "MRM Awards||MRM Training Workshop",
		// 	"serviceNameForList": "SR_MRM_TRAINING_WORKSHOP",
		// 	"id": 'mrm-training-workshop',
		// 	"sequence": 27,
		// 	"serviceName": "ورشة عمل تدريبية لبرنامج MRM",
		// 	"organization": "MRM Awards",
		// 	"parentServiceKey": "MRM_AWARDS",      
		// 	"serviceNameKey": "MRM_TRAINING_WORKSHOP",
		// 	"PreText": "",
		// 	"serviceDetail": {
		// 		"description": "",
		// 		"processingTime": "",
		// 		"feesNote": "",
		// 		"otherDetail": {
		// 			"greeting": "عزيزنا العضو الكريم،",
		// 			"intro": "سيختار المتقدمون فئة الجائزة التي يرغبون في التقديم الرسمي لها."
		// 		},
		// 	},
		// 	"serviceProcedure": [
		// 		{
		// 			"title": "الدخول إلى بوابة الخدمات",
		// 			"description": "انقر على «بدء الخدمة» لإنشاء حسابك أو تسجيل الدخول إلى بوابة خدمات غرف دبي."
		// 		},
		// 		{
		// 			"title": "تقديم الطلب",
		// 			"description": "قم بتقديم الشهادة أو الخطاب المطلوب عبر الموقع الإلكتروني وتزويد جميع المعلومات المطلوبة."
		// 		},
		// 		{
		// 			"title": "عملية الموافقة",
		// 			"description": "سيتم مراجعة طلبك والموافقة عليه خلال ساعتين من التقديم في حال استيفاء جميع المتطلبات."
		// 		},
		// 		{
		// 			"title": "الدفع والتأكيد",
		// 			"description": "بعد سداد الرسوم، سيُطلب منك تنزيل المستندات الخاصة بك."
		// 		}
		// 	],

		// 	"serviceFees": [
		// 		{
		// 			"title": "قد تختلف الرسوم بناءً على تفاصيل الطلب."
		// 		},
		// 		{
		// 			"title": "رسوم تدريب الطلب:",
		// 			"list": [
		// 				"عضو غرفة دبي: 2500 درهم إماراتي لكل مشارك",
		// 				"غير عضو: 3000 درهم إماراتي لكل مشارك"
		// 			]
		// 		},
		// 		{
		// 			"title": "*ملاحظة: تطبق رسوم ضريبة القيمة المضافة."
		// 		}
		// 	]
		// },

		// {
		//   "SRType": "Business Group & Councils||Business Group & Councils",
		//   "serviceNameForList": "MENU_BUSINESS_GROUP",
		//   "id": 'information-service',
		//   "sequence": 27,
		//   "serviceName": "Business Group & Councils",
		//   "organization": "Business Group & Councils",
		//   "PreText": "This service provides to whom it may concern letters and certification of recommendation and identification and company profile channels.",
		//   "serviceDetail": {
		//     "description": "Verify and authenticate the authorised signatory and related documents, correspondence, and contracts, ensuring they are accepted by the relevant authorities. This service helps our members by simplifying procedures and enhancing the credibility of their official documents.",
		//     "processingTime": "Two hours",
		//     "feesNote": "AED 210"
		//   },
		//   "serviceProcedure": [
		//     {
		//       "title": "Access services portal",
		//       "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal."
		//     },
		//     {
		//       "title": "Submit your application",
		//       "description": "Submit the requested certificate or letter through the website and provide all required information."
		//     },
		//     {
		//       "title": "Approval process",
		//       "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
		//     },
		//     {
		//       "title": "Payment and confirmation",
		//       "description": "After paying the fees, you will be prompted to download your documents."
		//     }
		//   ],
		//   "Beneficiaries": [
		//     {
		//       "title": "Beneficiaries",
		//       "description": "Dubai Chamber of Commerce members can apply for this service."
		//     }
		//   ],
		//   "serviceRequirements": {
		//     "title": "Here are the document requirements to apply for this service:",
		//     "list": [
		//       {
		//         "title": "A request letter from the company, signed and stamped by the authorised signatory at Dubai Chambers",
		//       }
		//     ]
		//   },
		//   "serviceFees": [
		//     {
		//       "title": "Letters and certificates fees",
		//       "list": [
		//         "To whom it may concern letter: AED 210"
		//       ]
		//     }, {
		//       "title": " Company profile fees",
		//       "list": [
		//         "Company Profile: AED 52.50"
		//       ]
		//     },

		//   ],
		//   "resources": [
		//     {
		//       "title": "Letters and Certificates – Service Page",
		//       "url": "https://www.dubaichambers.com/en/letters-and-certificates"
		//     },
		//     {
		//       "title": "Company Profile – Related Service",
		//       "url": "https://www.dubaichambers.com/en/company-profile"
		//     }
		//   ]
		// },
		// {
		//   "SRType": "Sustainability||Sustainability",
		//   "serviceNameForList": "MENU_SUSTAINABILITY",
		//   "id": 'information-service',
		//   "sequence": 27,
		//   "serviceName": "Sustainability",
		//   "organization": "Sustainability",
		//   "PreText": "This service provides to whom it may concern letters and certification of recommendation and identification and company profile channels.",
		//   "serviceDetail": {
		//     "description": "Verify and authenticate the authorised signatory and related documents, correspondence, and contracts, ensuring they are accepted by the relevant authorities. This service helps our members by simplifying procedures and enhancing the credibility of their official documents.",
		//     "processingTime": "Two hours",
		//     "feesNote": "AED 210"
		//   },
		//   "serviceProcedure": [
		//     {
		//       "title": "Access services portal",
		//       "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal."
		//     },
		//     {
		//       "title": "Submit your application",
		//       "description": "Submit the requested certificate or letter through the website and provide all required information."
		//     },
		//     {
		//       "title": "Approval process",
		//       "description": "Your request will be reviewed and approved within two hours of submission if you meet all the requirements."
		//     },
		//     {
		//       "title": "Payment and confirmation",
		//       "description": "After paying the fees, you will be prompted to download your documents."
		//     }
		//   ],
		//   "Beneficiaries": [
		//     {
		//       "title": "Beneficiaries",
		//       "description": "Dubai Chamber of Commerce members can apply for this service."
		//     }
		//   ],
		//   "serviceRequirements": {
		//     "title": "Here are the document requirements to apply for this service:",
		//     "list": [
		//       {
		//         "title": "A request letter from the company, signed and stamped by the authorised signatory at Dubai Chambers",
		//       }
		//     ]
		//   },
		//   "serviceFees": [
		//     {
		//       "title": "Letters and certificates fees",
		//       "list": [
		//         "To whom it may concern letter: AED 210"
		//       ]
		//     }, {
		//       "title": " Company profile fees",
		//       "list": [
		//         "Company Profile: AED 52.50"
		//       ]
		//     },

		//   ],
		//   "resources": [
		//     {
		//       "title": "Letters and Certificates – Service Page",
		//       "url": "https://www.dubaichambers.com/en/letters-and-certificates"
		//     },
		//     {
		//       "title": "Company Profile – Related Service",
		//       "url": "https://www.dubaichambers.com/en/company-profile"
		//     }
		//   ]
		// },

		// {
		//   "serviceId": "company-profile",
		//   "serviceName": "Company Profile",
		//   "organization": "Dubai Chambers",
		//   "url": "https://www.dubaichambers.com/en/company-profile",
		//   "serviceDetail": {
		//     "description": "This service allows you to apply for an official Company Profile from Dubai Chamber of Commerce. The profile includes key economic and registration information about your company, helping build trust with clients, partners and regulators and supporting business growth.",
		//     "processingTime": "Two hours",
		//     "feesNote": "Company Profile fee is AED 52.50."
		//   },
		//   "serviceProcedure": [
		//     {
		//       "title": "Access services portal",
		//       "description": "Click 'Start Service' to create your account or log in to the Dubai Chambers services portal."
		//     },
		//     {
		//       "title": "Submit your application",
		//       "description": "Follow the instructions to submit the Company Profile request through the website."
		//     },
		//     {
		//       "title": "Approval process",
		//       "description": "Your request will be reviewed and approved within two hours of submission if all requirements are met."
		//     },
		//     {
		//       "title": "Payment and confirmation",
		//       "description": "After paying the fees, you will be prompted to download your Company Profile document."
		//     }
		//   ],
		//   "Beneficiaries": [
		//     {
		//       "title": "Beneficiaries",
		//       "description": "Dubai Chamber of Commerce members and non-members can apply for this service."
		//     }
		//   ],
		//   "serviceRequirements": {
		//     "title": "Here are the document requirements to apply for this service:",
		//     "list": [
		//       {
		//         "title": "Online submission",
		//         "description": "Submit the Company Profile application through the Dubai Chambers website."
		//       }
		//     ]
		//   },
		//   "serviceFees": [
		//     {
		//       "title": "Company Profile fees",
		//       "list": [
		//         "Company Profile: AED 52.50."
		//       ]
		//     }
		//   ],
		//   "additionalInformation": {
		//     "otherChannels": "Provided as part of Dubai Chambers’ Business Research and Information services; all requirements are submitted online and processed within two hours.",
		//     "contact": "WhatsApp: (+971) 800 242 6237; toll-free within UAE: 800 242 6237 (800 CHAMBER); enquiry email and chat support are available via the Dubai Chambers website.",
		//     "location": "Dubai Chambers online services portal."
		//   },
		//   "howToApply": [
		//     "Open the Company Profile service page on the Dubai Chambers website and click 'Start Service'.",
		//     "Log in or register and submit the Company Profile request through the website.",
		//     "Pay the service fee and download the issued Company Profile once your request has been approved."
		//   ],
		//   "resources": [
		//     {
		//       "title": "Company Profile – Service Page",
		//       "url": "https://www.dubaichambers.com/en/company-profile"
		//     },
		//     {
		//       "title": "Dubai Chambers Service Manual – Information Services",
		//       "url": "https://www.dubaichambers.com/documents/20119/0/Service_Manual_En%2B%281%29.pdf"
		//     },
		//     {
		//       "title": "Letters and Certificates – Related Service",
		//       "url": "https://www.dubaichambers.com/en/letters-and-certificates"
		//     }
		//   ],
		//   "SRType": "",
		//   "id": "",
		//   "sequence": null
		// }
	]

}
